import { render, staticRenderFns } from "./ContactInfoEditDialog.vue?vue&type=template&id=6c8dc554&"
import script from "./ContactInfoEditDialog.vue?vue&type=script&lang=js&"
export * from "./ContactInfoEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./ContactInfoEditDialog.vue?vue&type=style&index=0&id=6c8dc554&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports